import React from 'react';
import { ReactComponent as FigCloudBlank01Component } from './FigCloudBlank01.svg';

const FigCloudBlank01 = (props) => <FigCloudBlank01Component {...props} />;

export default FigCloudBlank01;
